import type { ComponentProps } from 'react';
import React from 'react';
import styled from '@emotion/styled';
import type { ArticleUnitPricingMeasure } from 'graphql-ts-types';
import type { DisplayProps } from 'styled-system';
import { display } from 'styled-system';

import { useLocalization } from '../../providers/LocaleProvider';
import { BodyRegularBR2, CaptionRegularCR1 } from '../Typography';

interface UnitPriceProps {
  measurement: ArticleUnitPricingMeasure;
  isComplex?: boolean;
  className?: string;
}

const UnstyledContainer = styled.div<DisplayProps>`
  ${display};
`;

const Container = (props: ComponentProps<typeof UnstyledContainer>) => (
  <UnstyledContainer display="inline-flex" {...props} />
);

const UnitPrice = ({ measurement, isComplex, className }: UnitPriceProps) => {
  const { fc } = useLocalization();
  const StyledText = isComplex ? BodyRegularBR2 : CaptionRegularCR1;

  return (
    <Container className={className}>
      <StyledText as="span" fontWeight="normal">
        {`(${fc(measurement.value)} / ${measurement.quantity} ${measurement.unit})`}
      </StyledText>
    </Container>
  );
};

export default UnitPrice;
